export default __webpack_public_path__ + "static/media/1390.2d6b2b06.png";